import { useNavigate } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { NewSpendingPoliciesWizard } from 'modules/finance/components/NewPaymentPoliciesWizard'
import { CategoryOption } from 'modules/finance/lib/policy_types'
import { useSpendingPoliciesPage } from 'modules/finance/pages/SpendingPoliciesPage/useSpendingPolicies'

const NewSpendingPoliciesPage = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useSpendingPoliciesPage(company.id)

  const canCreateSpendingPolicy = data?.finance?._policies?.spendingPolicyCreate?.can ?? false
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const handleSuccess = (policyId: number) => {
    app.setFlash({ type: 'correct', message: i18n.t('common.saved_successfully') })

    navigate(navigation.expenses.spendingPolicies.detail.fullPath({ policyId }))
  }
  const handleError = () => {
    app.setFlash({ type: 'wrong', message: i18n.t('errors.generic_error') })
  }

  const categories: CategoryOption[] =
    data?.finance?.categories.nodes.map((category) => {
      return {
        value: category.id,
        label: category.label,
        identifier: category.identifier ?? undefined,
      }
    }) ?? []

  const subcategories: CategoryOption[] =
    data?.finance?.subcategories.nodes.map((subcategory) => {
      return {
        value: subcategory.id,
        label: subcategory.label,
        identifier: subcategory.identifier ?? undefined,
        parentCategoryId: subcategory.parentCategoryId?.toString(),
      }
    }) ?? []

  if (loading) return <Loading />
  else if (!canCreateSpendingPolicy) return <NotFound />
  return (
    <NewSpendingPoliciesWizard
      categories={categories}
      subcategories={subcategories}
      onSuccess={handleSuccess}
      onError={handleError}
    />
  )
}

export default NewSpendingPoliciesPage
